import React from 'react'
import { Select, SelectContent, SelectTrigger, SelectItem, SelectValue } from '@shopflo/ui'
import { CouponType, DiscountFieldPaths } from 'src/lib/types/discountsV2'
import { useDiscountForm } from '../../../hooks/useDiscountForm'
import DiscountPricingInput from '../../../common/DiscountPricingInput'

import { useLocale } from 'src/lib/hooks/useLocal'

const AmountOffPricingInputs = ({ showUpto = false }: { showUpto?: boolean }) => {
  const {
    state: { entitlement, errors }
  } = useDiscountForm()
  const { t } = useLocale()

  if (entitlement.type !== CouponType.AMOUNT) return null

  return (
    <div className='grid grid-cols-2 gap-3 w-full pb-6'>
      <div>
        <DiscountPricingInput error={errors[DiscountFieldPaths.CONCESSION_AMOUNT]} showUpto={showUpto} />
      </div>

      <div>
        <Select value='on_product' disabled>
          <SelectTrigger
            id='on-purchased-items-trigger'
            className='w-full h-9 bg-zinc-50 rounded-lg opacity-100 cursor-default text-zinc-800'
            showCaret={false}
          >
            <span className='p-1'>{t('discounts_v2.on_purchased_items')}</span>
          </SelectTrigger>
        </Select>
      </div>
    </div>
  )
}

export default AmountOffPricingInputs
